import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';

// components
import { MatStepperCustomComponent } from './mat-stepper-custom.component';
import { MatStepperCustomStepComponent } from './mat-stepper-custom-step/mat-stepper-custom-step.component';

// modules shared
import { SharedModule } from '@shared/shared.module';
import { PriceInformationModule } from '@shared/price-information/price-information.module';
import { SelectCurrencyModule } from '@shared/select-currency/select-currency.module';
import { PaymentMethodListModule } from '@shared/payment-method-list/payment-method-list.module';
import { CurrencyMoneyModule } from '@shared/currency-money/currency-money.module';
import { TreoMessageModule } from '@treo/components/message';

const COMPONENTS = [MatStepperCustomComponent, MatStepperCustomStepComponent];

const MATERIAL = [MatButtonModule, MatIconModule];

const MODULES = [
  PriceInformationModule,
  SelectCurrencyModule,
  PaymentMethodListModule,
  CurrencyMoneyModule,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    ...MATERIAL,
    SharedModule,
    MatStepperModule,
    MatProgressBarModule,
    TreoMessageModule,
  ],
  exports: [
    ...COMPONENTS,
    ...MODULES,
    ...MATERIAL,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    TreoMessageModule,
  ],
})
export class MatStepperCustomModule {}
